import type { ChangeEvent, ChangeEventHandler, FocusEventHandler } from 'react';
import { cn } from '@/utils/сn';
import { Input } from '../Input';
import CrossIcon from '/public/icons/cross.svg';
import SearchIcon from '/public/icons/search.svg';

interface SearchProps {
  name: string;
  placeholder?: string;
  value?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  className?: string;
  autoComplete?: string;
  disabled?: boolean;
  intent?: 'search' | 'searchLarge';
  testId?: string;
}

export const Search = ({
  name,
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  className,
  autoComplete,
  disabled,
  intent,
  testId,
}: SearchProps) => {
  const onClear = () => {
    onChange?.({ target: { name, value: '' } } as ChangeEvent<HTMLInputElement>);
  };

  return (
    <div className={cn('relative', className)} data-testid={testId}>
      <Input
        intent={intent}
        startIcon={intent ? undefined : <SearchIcon className="w-4.5 h-4.5" />}
        endIcon={value && !disabled ? <CrossIcon className="w-3 h-3 cursor-pointer" onClick={onClear} /> : undefined}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        autoComplete={autoComplete}
        disabled={disabled}
        data-testid={testId ? `${testId}-input` : undefined}
      />
    </div>
  );
};
